import { createFileRoute } from "@tanstack/react-router";
import PrivacyPolicy from "@/components/PrivacyPolicy";

export const Route = createFileRoute("/personvern")({ component: PersonvernPage });

function PersonvernPage() {
  return <PrivacyPolicy norwegian />;
}
